<template>
	<router-view/>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { client } from '@/api/client';
import { clientSupplier } from '@/api/supplier/client';

export default {
	computed: {
		...mapState(['pageTitle', 'progressStatus']),

		title() {
			let splitPath = this.$route.path.split('/')
			let tipe = ''
			switch (splitPath[1]) {
				case 'supplier':
				tipe = 'Supplier'
				break;
				case 'logistic':
				tipe = 'Logistik'
				break;
				case 'auth':
				tipe = ''
				break;
				default:
				tipe = 'Warehouse'
				break;
			}
			if (tipe) {
				return `${this.pageTitle} - ${tipe}`;
			} else {
				return `${this.pageTitle}`;
			}
		},
	},
	watch: {
		pageTitle(val, oldVal) {
			if (val !== oldVal) {
				document.title = this.title;
			}
		},

		progressStatus(val, oldVal) {
			if (val !== oldVal) {
				switch (val) {
					case 'start':
					this.$Progress.start();
					break;
					case 'fail':
					this.$Progress.fail();
					break;
					default:
					this.$Progress.finish();
					break;
				}
			}
		},
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapActions('authSupplier', ['logoutsupplier']),

		forceLogoutWarehouse() {
			this.logout().then(() => {
				this.$router.push({ name: 'login' }).catch(()=>{});
			});
		},
		forceLogoutSupplier() {
			this.logoutsupplier().then(() => {
				this.$router.push({ name: 'login-supplier' });
			});
		},
	},
	created() {
		client.interceptors.response.use(undefined, (error) => {
			return new Promise(() => {
				if (error.response.status === 406) {
					this.forceLogoutWarehouse();
				}
				throw error;
			});
		});
		clientSupplier.interceptors.response.use(undefined, (error) => {
			return new Promise(() => {
				if (error.response.status === 406) {
					this.forceLogoutSupplier();
				}
				throw error;
			});
		});
	},
};
</script>

<style lang="scss">
@import "./styles/theme";
@import "./styles/page";
</style>